import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'dashboard/v2/favorite/reports';
export const fetchFavoriteReports = () => http.get(BASE_URL).then(fromJS);